import React from 'react';

import { X } from 'lucide-react';

// Chrome shared by every settings-style modal, in one place so the seven-odd
// modals can't drift: the close button spec (rail icon-button: 36px circle,
// 0.5px white border, white hover — pairs with SettingsBackButton), its X
// glyph, and the top-bar title type.
export const SETTINGS_MODAL_CLOSE_BUTTON_CLASS =
  'top-5 left-5 size-9 border-[0.5px] border-white bg-gray-50 shadow-[0px_4px_4px_rgba(0,0,0,0.02)] hover:bg-white md:left-5 dark:border-white/10 dark:bg-neutral-900 dark:hover:bg-neutral-800';

export const SETTINGS_MODAL_CLOSE_ICON = <X className="pointer-events-none size-4.5" strokeWidth={2} absoluteStrokeWidth />;

export const SETTINGS_MODAL_TITLE_CLASS = 'truncate text-base leading-5 font-medium text-black dark:text-neutral-200';

// The blue Save pill that sits in the modal top bar, opposite the back/close
// button — the settings-page counterpart of accountStyles' FIELD_SUBMIT_BUTTON_CLASS.
export const SETTINGS_MODAL_SAVE_PILL_CLASS =
  'absolute top-5 right-5 z-(--stack-modal-close) flex h-9 w-15 cursor-pointer items-center justify-center rounded-full bg-idle-blue text-sm leading-[18px] font-medium text-white hover:opacity-90 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500 dark:disabled:bg-neutral-800 dark:disabled:text-neutral-500';
